module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/language/language-master/language-master.component.scss
// module id = ./src/app/component/language/language-master/language-master.component.scss
// module chunks = main